import { NgModule } from '@angular/core';
import { NotificationService } from './notification.service';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { RoleCheckDirective } from './role-check-directive';
import { provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '../../environments/environment';

@NgModule({
  declarations: [RoleCheckDirective],
  imports: [NzNotificationModule],
  providers: [
    NotificationService,
    provideAuth0({
      domain: environment.auth0Domain,
      clientId: environment.auth0ClientId,
      authorizationParams: {
        redirect_uri: environment.redirectUrl,
        scope: 'openid profile email offline_access',
        //audience: 'markant-mediabase-api',
      },
      cacheLocation: 'localstorage',
      useRefreshTokens: true,
    }),
  ],
  exports: [RoleCheckDirective],
})
export class CoreModule {}
